// extracted by mini-css-extract-plugin
export var container = "PaginationLinks-module--container--k5Va8";
export var linkPrevious = "PaginationLinks-module--link-previous--ro+Qf";
export var linkNext = "PaginationLinks-module--link-next--4gLDF";